<template>
  <div class="article-details">
    <a class="title" :href="pdfUrl" target="_blank">{{title}}</a>
    <div class="article-author">{{author}}</div>
  </div>
</template>

<script>

export default {
  name: 'ArticleDetails',
  props: ['article'],
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    title () {
      return this.article.title
    },
    author () {
      return this.article.author
    },
    pdfUrl () {
      return this.article.link
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  display: list-item;
  list-style-type: disc;
  list-style-position: outside;
  margin-left: 15px;
}
.article-author {
  font-style: italic;
  font-size: 12px;
  padding-left: 22px;
}
</style>